var bayernQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Freistaat Bayern?',
    image: '311',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Bayern?',
    answers: [
      {
        content: 'Prignitz',
        key: 0,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 0,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 1,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Bayern gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Bayern bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Bayern?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'weiß-blau',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Bayern über politische Themen informieren?',
    answers: [
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Bayern heißt ...',
    answers: [
      {
        content: 'Ingolstadt.',
        key: 0,
      },
      {
        content: 'Regensburg.',
        key: 0,
      },
      {
        content: 'Nürnberg.',
        key: 0,
      },
      {
        content: 'München.',
        key: 1,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Bayern?',
    image: '318',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Bayern?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Bayern',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Bayern nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Bayern',
  },
]

export default bayernQuestions
